var storefrontApp = angular.module("storefrontApp");

storefrontApp.service("membershipService", [
    "$http",
    function ($http) {
        return {
            getMembershipPlans: function () {
                return $http.get("storefrontapi/club/membershipplans");
            },
            placeTrialMembershipOrder: function (membershipCheckoutInfo) {
                return $http.post(
                    "storefrontapi/club/placetrialmembershiporder",
                    membershipCheckoutInfo
                );
            },
        };
    },
]);
